import moment from 'moment'

export const sizeConverter = (size) => {
  if (size.toString().length > 6) {
    return `${Math.ceil(size / 1000000)} MB`
  } else {
    return `${Math.ceil(size / 1000)} KB`
  }
}
export const calculateTax = (price) => {
  if (price) {
    return price * (10 / 100)
  }
  return 0
}

export const displayCampaignStatus = (status) => {
  let value = status
  if (status.toLowerCase() == 'waiting for approval') {
    value = 'waiting approval'
  } else if (status.toLowerCase() == 'waiting for payment') {
    value = 'waiting payment'
  }

  return value.charAt(0).toUpperCase() + value.slice(1)
}

export const formatShortDate = (date) => {
  var retval = new Date(date);
  var options = { year: 'numeric', month: 'short', day: '2-digit' };
  return retval.toLocaleDateString("en-GB", options)
}
export const formatShortDateTime = (date) => {
  var retval = new Date(date);
  var options = { year: 'numeric', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit'  };
  return retval.toLocaleDateString("en-GB", options)
}
export const formatLongDate = (date) => {
  var retval = new Date(date);
  var options = { weekday: 'long', year: 'numeric', month: 'long', day: '2-digit' };
  return retval.toLocaleDateString("en-GB", options)
}
export const formatFullDate = (date) => {
  var retval = new Date(date);
  var options = { weekday: 'long', year: 'numeric', month: 'long', day: '2-digit', hour: '2-digit', minute: '2-digit' };
  return retval.toLocaleDateString("en-GB", options)
}
export const formatShortMonthYear = (date) => {
  var retval = new Date(date);
  var options = { year: 'numeric', month: 'short' };
  return retval.toLocaleDateString("en-GB", options)
}

export const dateFormat = (formatInput, formatOutput, date) => {
  return moment(date, formatInput).format(formatOutput)
}

let lib = {
  sizeConverter,
  calculateTax,
  formatShortDate,
  formatLongDate,
  formatFullDate,
  dateFormat,
  displayCampaignStatus
}
export default lib